// EntityContextMenu.tsx — Right-click context menu for entities and empty panel
import './EntityContextMenu.css';

interface Props {
  screenX: number;
  screenY: number;
  entityId: string | null;        // null = right-clicked empty panel
  hasClipboard: boolean;          // true if something was copied
  onEdit: (entityId: string) => void;
  onCopy: (entityId: string) => void;
  onDelete: (entityId: string) => void;
  onPaste: () => void;
  onClose: () => void;
}

export default function EntityContextMenu({
  screenX, screenY, entityId, hasClipboard,
  onEdit, onCopy, onDelete, onPaste, onClose,
}: Props) {
  return (
    <div className="ecm-backdrop" onMouseDown={onClose} onContextMenu={e => { e.preventDefault(); onClose(); }}>
      <div
        className="entity-context-menu"
        style={{ left: screenX, top: screenY }}
        onMouseDown={e => e.stopPropagation()}
      >
      {entityId ? (
        <>
          <button className="ecm-item" onClick={() => onEdit(entityId)}>Edit</button>
          <button className="ecm-item" onClick={() => onCopy(entityId)}>Copy</button>
          <button className="ecm-item ecm-danger" onClick={() => onDelete(entityId)}>Delete</button>
        </>
      ) : (
        <button
          className={`ecm-item${hasClipboard ? '' : ' ecm-disabled'}`}
          onClick={hasClipboard ? onPaste : undefined}
          disabled={!hasClipboard}
        >
          Paste
        </button>
      )}
      </div>
    </div>
  );
}
